import { render, staticRenderFns } from "./performance-card.vue?vue&type=template&id=1c9de9da&scoped=true"
import script from "./performance-card.ts?vue&type=script&lang=ts&external"
export * from "./performance-card.ts?vue&type=script&lang=ts&external"
import style0 from "./performance-card.scss?vue&type=style&index=0&id=1c9de9da&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9de9da",
  null
  
)

export default component.exports